import { render, staticRenderFns } from "./PlanStep4.vue?vue&type=template&id=38fc3f99&scoped=true&"
import script from "./PlanStep4.vue?vue&type=script&lang=js&"
export * from "./PlanStep4.vue?vue&type=script&lang=js&"
import style0 from "./PlanStep4.vue?vue&type=style&index=0&id=38fc3f99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc3f99",
  null
  
)

export default component.exports